import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import ProductProp from '../propTypes/productProp';
import CustomRadio from '../../../commonComponents/forms/inputs/CustomRadio';
import { FrequencySubscriptionTypes } from '../../../services/utilityFunctions';

function ProductSubscriptionDebitDate({ t, product, frequency }) {
  const { subscriptionFrequencyDebitDates } = product;
  const { weekly, monthly } = subscriptionFrequencyDebitDates || {};
  const weeklyOptions = useMemo(
    () => [
      { id: 1, text: t('week.monday') },
      { id: 2, text: t('week.tuesday') },
      { id: 3, text: t('week.wednesday') },
      { id: 4, text: t('week.thursday') },
      { id: 5, text: t('week.friday') },
      { id: 6, text: t('week.saturday') },
      { id: 7, text: t('week.sunday') },
    ],
    [weekly, t],
  );

  const message = useMemo(() => {
    if (frequency === FrequencySubscriptionTypes.WEEKLY) {
      const hasWeeklyText = weeklyOptions.find(w => w.id === weekly)?.text;
      return weekly && hasWeeklyText
        ? t('product.subscription.debit.date', hasWeeklyText)
        : null;
    }

    return frequency === FrequencySubscriptionTypes.MONTHLY && monthly
      ? t('product.subscription.debit.date.month', monthly)
      : null;
  }, [t, frequency, weekly, monthly]);
  return (
    <>
      {message ? (
        <div className="debitDate-container">
          <span>{message}</span>
        </div>
      ) : null}
    </>
  );
}

ProductSubscriptionDebitDate.propTypes = {
  t: PropTypes.func.isRequired,
  product: PropTypes.shape(ProductProp.propType).isRequired,
  frequency: PropTypes.string.isRequired,
};

export default translate(ProductSubscriptionDebitDate);
